/* @flow */

export default class EligibilityAnswer {
  id: number;
  text: string;
  isSelected: boolean;
}
